<template>
<div class="mt-3 py-5">
	<b-container class="px-3 p-md-0">
		<b-row>
			<b-col cols="12" md='12' sm="10" class="sign-up-top pb-4 m-auto p-0">

			  <template v-if="display==1">

				<div class="back_ground_image1 container pt-5 pb-5 mb-auto">
					<div class="row justify-content-center pt-2 pb-2">

						<template v-if="String(user_type) == '1'">
							<div class="col-md-1"></div>
							<div class="col-md-4">
							<h2>一般の方専用</h2>
							<p>こちらは、一般の方専用の新規アカウント登録フォームです。メールアドレスとパスワードのご登録からスタートしてください。</p>
							<p><font color=red>※販売者の方は、ここからは新規登録ができません。</font></p>
							<ul>
							<li><p><a href="/about_piachu">ピアチュウとは？</a></p></li>
							<li><p><a href="/charge_user">登録・利用無料</a></p></li>
							</ul>
							</div>
							<div class="col-md-1"></div>
						</template>
						<template v-else-if="String(user_type) == '2'">
							<div class="col-md-1"></div>
							<div class="col-md-4">
							<h2>販売者の方専用</h2>
							<!-- 
							<p>こちらは、一般の方専用の新規アカウント登録フォームです。メールアドレスとパスワードのご登録からスタートしてください。</p>
							<p><font color=red>※結婚相談所運営の方は、ここからは新規登録ができません。</font></p>
							<ul>
							<li><p><a href="https://www.konkatuyama.com/about_konkatuyama">ピアチュウとは？</a></p></li>
							<li><p><a href="https://www.konkatuyama.com/charge_user">登録・利用無料</a></p></li>
							</ul>
							-->
							</div>
							<div class="col-md-1"></div>
						</template>

						<div class="col-md-1"></div>
						<div class="col-md-4">
							<div class="card">


								<div class="card-body">

									<div class="form-group row">
										<div class="col-md-12">
											<input type="text" class="form-control" v-model="signUpForm.nickname" required autofocus placeholder="ユーザ名（ハンドルネーム）" v-bind:class="{ error_input: signUpForm.errors.nickname.length > 0 }">
											<div v-if="signUpForm.errors.nickname.length > 0">
												<div class="error-text" v-for="(item, index) in signUpForm.errors.nickname" :key="index">{{ item }}</div>
											</div>
										</div>
									</div>

									<div class="form-group row">
										<div class="col-md-12">
											<input type="email" class="form-control" v-model="signUpForm.email" required placeholder="メールアドレス" v-bind:class="{ error_input: signUpForm.errors.email.length > 0 }">
											<div v-if="signUpForm.errors.email.length > 0">
												<div class="error-text" v-for="(item, index) in signUpForm.errors.email" :key="index">{{ item }}</div>
											</div>
										</div>
									</div>

									<div class="form-group row">
										<div class="col-md-12">
											<input type="password" class="form-control" v-model="signUpForm.password" required placeholder="パスワード" v-bind:class="{ error_input: signUpForm.errors.password.length > 0 }">
											<div v-if="signUpForm.errors.password.length > 0">
												<div class="error-text" v-for="(item, index) in signUpForm.errors.password" :key="index">{{ item }}</div>
											</div>
										</div>
									</div>

									<div class="form-group row">
										<div class="col-md-12">
											<input type="password" class="form-control" v-model="signUpForm.re_password" required placeholder="パスワード（確認）" v-bind:class="{ error_input: signUpForm.errors.re_password.length > 0 }">
											<div v-if="signUpForm.errors.re_password.length > 0">
												<div class="error-text" v-for="(item, index) in signUpForm.errors.re_password" :key="index">{{ item }}</div>
											</div>
										</div>
									</div>

									<div class="form-group row">
										<div class="col-md-12">
											<button type="submit" class="m-0 col-md-12 btn btn-success" @click="sign_up_exec">
												登録
											</button>
										</div>
									</div>

								</div>
							</div>
						</div>
						<div class="col-md-1"></div>
					</div>
				</div>

			  </template>

			  <template v-else-if="display==2">

				<div class="back_ground_image1 container pt-5 pb-5 text-center mb-auto">
				<div class="row justify-content-center">
					<div class="col-md-1"></div>
					<div class="col-md-10 mt-5">この度は、仮登録をいただき、誠にありがとうございます。
					<br>
					<br>ご本人様確認のため、ご登録いただいたメールアドレスに、本登録のご案内のメールが届きます。
					<br>
					<br>そちらに記載されているURLにアクセスし、アカウントの本登録を完了させてください。
					<br>
					<br>
					<br>
					<font color="#FF0000">※ 30分以上経ってもメールが届かない場合、他のメールアドレスでお試しください。</font>
					<br>
					<font color="#FF0000">また、合わせて以下の項目もご確認ください。</font>
					<br>
					<br>・メールソフトによっては自動的にごみ箱・迷惑メールフォルダに移動されている場合もあります。
					<br>それらのフォルダ内をご確認いただくとともに、ご利用メールソフトの設定をご確認ください。
					<br>・ブラウザでメールを確認できる場合は、ブラウザメールでもご確認いただきますようお願いいたします。
					<br>・docomo、au、softbank等の携帯電話（スマートフォンを含む）のメールアドレスをご利用の場合、設定によりメールが受信できない場合がございます。
					<br>指定受信設定をされている場合は、ドメイン"piachu.net"を受信可能に設定してください。
					<br>
					<br>その他の設定も含め、各携帯電話会社にて迷惑メール設定の案内がありますので、下記もご参照ください。
					<br>NTTドコモ→迷惑メール対策の設定一覧
					<br>au→迷惑Eメール防止方法
					<br>ソフトバンク→迷惑メールブロック設定方法
					<br>
					<br>ご不明の際は、
					<a href="https://www.piachu.net/contact">こちら</a>からお問い合わせください。
					</div>
					<div class="col-md-1"></div>
				</div>
				</div>

			  </template>

			  <template v-else-if="display==3">

				<div class="back_ground_image1 container pt-5 pb-5 text-center mb-auto">
					<div class="row justify-content-center">

						<div class="col-md-1">
						</div>
						<div class="col-md-10 mt-5">
							{{ message }}
						</div>
						<div class="col-md-1">
						</div>

					</div>
				</div>

			  </template>

			</b-col>
		</b-row>
	</b-container>
</div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	name: 'SignUp',
	data () {
		return {
			message: "",
			token: null,
			user_type: 1,
			display: 1,
			isError: false,
			processing: false,
			signUpForm: {
				errors: {
					nickname: [],
					email: [],
					password: [],
					re_password: [],
				},
				nickname: "",
				email: "",
				password: "",
				re_password: "",
				user_type: 1,
			},
		}
	},
	methods: {
		sign_up_exec() {
			this.isError = false;
			this.signUpForm.errors.nickname = [];
			this.signUpForm.errors.email = [];
			this.signUpForm.errors.password = [];
			this.signUpForm.errors.re_password = [];
			this.signUpForm.errors.agreement = [];
			if (!this.signUpForm.nickname) {
				this.signUpForm.errors.nickname.push('ニックネームが入力されていません');
				this.isError = true;
			}
			if (!this.signUpForm.email) {
				this.signUpForm.errors.email.push('メールアドレスが入力されていません');
				this.isError = true;
			} else {
				if (this.check_mail(this.signUpForm.email)) {
					this.signUpForm.errors.email.push('正しいメールアドレスを入力してください');
					this.isError = true;
				}	
			}
			if (!this.signUpForm.password) {
				this.signUpForm.errors.password.push('パスワードが入力されていません');
				this.isError = true;
			}
			if (!this.signUpForm.re_password) {
				this.signUpForm.errors.re_password.push('確認用パスワードが入力されていません');
				this.isError = true;
			}
			if (this.signUpForm.password && this.signUpForm.re_password && this.signUpForm.password != this.signUpForm.re_password) {
				this.signUpForm.errors.re_password.push('同じパスワードを入力してください');
				this.isError = true;
			}
			if (this.signUpForm.password && this.signUpForm.re_password && this.signUpForm.password == this.signUpForm.re_password) {
				if(!(this.signUpForm.password.match(/[A-Za-z]/)&&this.signUpForm.password.match(/[0-9]/)&&this.signUpForm.password.length > 7)){
					this.signUpForm.errors.re_password.push('パスワードは半角英数混合で8文字以上を入力してください');
					this.isError = true;
				}
			}
			if (this.isError) {
				window.scrollTo({
					top: 0,
				});
				return false;
			} else {
				window.scrollTo({
					top: 0,
				});
				if ( !this.processing ) {
					this.signUpForm.user_type = this.user_type;
					this.pre_regist_send();
				}
			}
	    },

		async pre_regist_send() {
			this.processing = true;
			this.$store.dispatch('auth/pre_regist', {
				users: this.signUpForm,
			}).then(response => {
				this.processing = false;
				console.log('正常');
				console.log(response);
				this.display = 2;
				window.scrollTo({
					top: 0,
				});
			}, error => {
				console.log('error発生');
				console.log(error.response.data);
				this.processing = false;
				this.signUpForm.errors.email = [];
				if ('error' in error.response.data) {
					this.signUpForm.errors.email.push(error.response.data['error']);
					this.isError = true;
					window.scrollTo({
						top: 0,
					});
				}
			});
			return false;
		},

        async auth_check() {
            this.$store.dispatch('auth/email_token_check', {
                token: this.$route.query.token,
            }).then(res => {
                console.log(res);
                console.log('認証OK');
				this.$router.push({path: '/'});
            }, error => {
                console.log('error発生');
				console.log(error.response.data);
				if ('error' in error.response.data) {
					this.message = error.response.data['error'];
					window.scrollTo({
						top: 0,
					});
				}
            });
        },

	},
    created() {
		this.user_type = this.$route.query.user_type;
		this.token = this.$route.query.token;
		if ( this.token != null && this.token != '' ) {
			this.display = 3;
			this.auth_check();
		}
    },
	
}
</script>

<style scoped>
.frame-head {
	border-bottom: 2px solid #EEF2F7;
}

.frame-head h3 {
	font-size: 24px;
}

.btn-client {
	background-color: #00B9AE;
	border-color: #00B9AE;
}

.btn-client:hover {
    background: #009F96;
    border-color: #009F96;
}

.btn-writer {
	background-color: #308AE1;
	border-color: #308AE1;
}

@media screen and (max-width: 575px) {
	/* .card {
		border: none;
	} */

	.frame-head {
    	border-bottom: none;
	}

	.frame-head h3 {
 	   	font-size: 20px;
	}

	.frame-footer {
		border-top: none;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/SignUp.vue